module.exports = __webpack_public_path__ + "static/media/Sulzer.6aa1bf15.webp";